import { EpicRefined } from 'interfaces/middleware'
import { VideoCallAction, AgoraScreenShareAction, AgoraStopScreenShareAction, AgoraLeaveChannelAction } from 'components/features/videoCalls/types/actions'
import { filterRequestOfType } from 'rxOperators/filterRequestOfType'
import { mergeMap, catchError, takeUntil } from 'rxjs/operators'
import { of, merge, EMPTY } from 'rxjs'
import { fromScreenStreamEvents, createAgoraClient, publishStream, unpublishStream, agoraClientLeave } from 'components/features/videoCalls/agoraHelpers'
import { mergeMapAsync } from 'rxOperators/mergeMapAsync'
import { agoraInstances } from 'components/features/videoCalls/agoraInstances'

export const screenShareEpic: EpicRefined<VideoCallAction> = (action$, store) => action$.pipe(
  filterRequestOfType(AgoraScreenShareAction.type, 'request'),
  mergeMap((action) => of(null).pipe(
    mergeMapAsync(async () => {
      const { stream } = action.payload.params
      const state = store.getState()
      const connection = state.data.advisors.videoCallDetails.details?.video?.connection
      if (!connection) {
        throw new Error()
      }

      const { screen_share_token, channel, screen_share_uid } = connection
      const { client, localStreamId } = await createAgoraClient(screen_share_token, channel, screen_share_uid)

      await publishStream(client, stream)

      agoraInstances.streams.set(localStreamId, stream)
      const clientId = agoraInstances.addClient(client)
      return {
        localStreamId,
        clientId,
        stream,
      }
    }),
    mergeMap(({ localStreamId, clientId, stream }) => merge(
      fromScreenStreamEvents(stream).pipe(
        takeUntil(
          action$.pipe(
            filterRequestOfType(AgoraStopScreenShareAction.type, 'success')
          )
        )
      ),
      of(action.success({ localStreamId, clientId }))
    )),
    catchError((error) => {
      if (error.msg === 'This browser does not support screen sharing') {
        return of(action.fail({ unavailable: true }))
      }

      return of(action.fail({}))
    })
  ))
)


export const stopScreenShareEpic: EpicRefined<VideoCallAction> = (action$, store) => action$.pipe(
  filterRequestOfType(AgoraStopScreenShareAction.type, 'request'),
  mergeMap((action) => of(null).pipe(
    mergeMapAsync(async () => {
      const { clientId, streamId } = store.getState().app.videoCall.screenStream

      const client = agoraInstances.clients.get(clientId as any)
      if (!clientId || !client) {
        throw new Error()
      }

      const stream = agoraInstances.streams.get(streamId as any)
      if (!streamId || !stream) {
        throw new Error()
      }
      stream.stop()
      stream.close()
      try {
        await unpublishStream(client, stream)
      } catch (e) {}

      try {
        await agoraClientLeave(client)
      } catch (e) {}

      agoraInstances.clients.delete(clientId)
      agoraInstances.streams.delete(streamId)
      return action.success({ streamId })
    }),
    catchError(() => {
      return of(action.fail())
    })
  )),
)

export const stopScreenShareOnLeaveChannelEpic: EpicRefined<VideoCallAction> = (action$, store) => action$.pipe(
  filterRequestOfType(AgoraLeaveChannelAction.type, 'request'),
  mergeMap(() => {
    if (!store.getState().app.videoCall.screenStream.streamId) {
      return EMPTY
    }
    return of(new AgoraStopScreenShareAction())
  }),
)
